import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "../lib/api";
import { BuddyLogo, LumiMascot } from "../components/Brand";
import LanguageSwitcher from "../components/LanguageSwitcher";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";

export default function Activation() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  async function redeem(e) {
    e.preventDefault();
    if (!user) { nav("/login"); return; }
    setBusy(true);
    try {
      const r = await api.post("/activation/redeem", { code: code.trim().toUpperCase() });
      setResult(r.data);
      toast.success(t("activation.success"));
    } catch (err) { toast.error(err?.response?.data?.detail || t("activation.failed")); }
    finally { setBusy(false); }
  }

  return (
    <div className="min-h-screen student-bg">
      <header className="hb-glass sticky top-0 z-30">
        <div className="max-w-[900px] mx-auto px-6 py-3 flex items-center justify-between">
          <Link to="/"><BuddyLogo /></Link>
          <div className="flex items-center gap-2"><LanguageSwitcher /><Link to="/"><Button variant="ghost">{t("common.home")}</Button></Link></div>
        </div>
      </header>
      <main className="max-w-[900px] mx-auto px-6 py-10 grid md:grid-cols-2 gap-8 items-center">
        <div className="flex flex-col items-center">
          <LumiMascot size={180} />
          <h1 className="font-student font-bold text-3xl text-slate-900 mt-4">{t("activation.title")}</h1>
          <p className="text-slate-600 text-center max-w-sm">{t("activation.subtitle")}</p>
        </div>
        <div className="hb-card p-8 hb-chunky-shadow">
          <form onSubmit={redeem}>
            <label className="text-sm font-semibold text-slate-700">{t("activation.code")}</label>
            <Input value={code} onChange={(e) => setCode(e.target.value)}
                   placeholder="LUMI-DEMO-001" data-testid="activation-code-input"
                   className="mt-1 tracking-widest font-mono uppercase" required />
            <Button type="submit" disabled={busy} data-testid="activation-redeem-btn"
                    className="w-full mt-4 bg-slate-900 hover:bg-slate-800 text-white rounded-full py-6">
              {busy ? t("activation.activating") : user ? t("activation.redeem") : t("activation.signInFirst")}
            </Button>
          </form>
          {result && (
            <div className="mt-6 rounded-2xl bg-green-50 border border-green-200 p-4" data-testid="activation-result">
              <div className="font-semibold text-green-900">{t("activation.trialActive", { n: result.trial_days })}</div>
              <div className="text-xs text-green-700 mt-1">{t("activation.expiresAt", { d: new Date(result.trial_expires_at).toLocaleString() })}</div>
              <Link to="/app" className="inline-block mt-2"><Button size="sm" className="rounded-full">{t("activation.goToApp")}</Button></Link>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
